import React from 'react';

class NotFound extends React.Component {
    render() {
        return <div>404 Page not found</div>;
    }
}

export default NotFound;
